<template>
  <div class="product-block__description-area">
    <!-- ««« Табы-->
    <div class="product-tabs">
      <nav class="product-tabs__nav">
        <ul class="product-tabs__nav-list">
          <li class="product-tabs__nav-item">
            <a
              @click="showTab(0)"
              :class="[tab_index == 0 ? 'is-active' : '']"
              class="product-tabs__nav-button list-button list-button_for-light"
              data-tab="desc"
            >
              <span class="list-button__text">Описание</span>
            </a>
          </li>
          <li class="product-tabs__nav-item">
            <a
              @click="showTab(1)"
              :class="[tab_index == 1 ? 'is-active' : '']"
              class="product-tabs__nav-button list-button list-button_for-light"
              data-tab="spec"
            >
              <span class="list-button__text">Характеристики</span>
            </a>
          </li>
          <li v-if="product.video.length > 0" class="product-tabs__nav-item">
            <a
              @click="showTab(2)"
              :class="[tab_index == 2 ? 'is-active' : '']"
              class="product-tabs__nav-button list-button list-button_for-light"
              data-tab="mov"
            >
              <span class="list-button__text">Видеообзор</span>
            </a>
          </li>
        </ul>
      </nav>

      <div class="product-tabs__body">
        <div
          :class="[tab_index == 0 ? 'is-active' : '']"
          class="product-tabs__tab is-des"
          data-tab="desc"
        >
          <div class="article" v-html="product.description"></div>
        </div>
        <div
          :class="[tab_index == 1 ? 'is-active' : '']"
          class="product-tabs__tab is-spec"
          data-tab="spec"
        >
          <div class="specification">
            <h4 class="specification__heading">Основные сведения</h4>
            <table class="specification__table">
              <tbody>
                <tr
                  v-for="property in properties"
                  :key="property.id"
                  class="specification__t-row"
                >
                  <td class="specification__t-name-cell">
                    <div class="specification__t-name">
                      <div class="specification__t-name-text-wrapper">
                        <span class="specification__t-name-text"
                          >{{ property.name }}&#8199;</span
                        >
                      </div>
                    </div>
                  </td>
                  <td class="specification__t-value-cell">
                    <span class="specification__t-value">{{
                      property.value
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          :class="[tab_index == 2 ? 'is-active' : '']"
          class="product-tabs__tab is-mov"
          data-tab="mov"
        >
          <div v-html="product.video"></div>
        </div>
      </div>
    </div>
    <!-- Табы »»»-->
  </div>
</template>

<script>
export default {
  name: "ProductDescription",
  data() {
    return {
      tab_index: 0,
    };
  },
  computed: {
    product() {
      return this.$store.getters["product/GET_PRODUCT"];
    },
    properties() {
      return this.$store.getters["product/GET_PROPERTIES"];
    },
  },
  methods: {
    showTab(tab_index) {
      this.tab_index = tab_index;
    },
  },
};
</script>

<style scoped></style>
